import React, {useEffect} from "react";
import "../CSS/styles.css";
import ris from "../../assets/ris.png";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Slider4 = () => {
  useEffect(() => {
        AOS.init({
          duration: 1000,
          once: false,
        });
      }, []);
  return (
    <div className="container-fluid mt-lg-5 mt-4 px-0" data-aos="fade-down">
      <div className="row pt-4 justify-content-center">
        <div className="col-12">
          <div className="image-gradient-wrap3">
            <img src={ris} alt="2" className="img-fluid" />
            <div className="gradient-over3"></div>
            <div className="over-cont3 d-flex flex-column align-items-center justify-content-center">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M39.9863 25.9937C39.9863 35.9913 32.988 40.99 24.6701 43.8893C24.2345 44.0369 23.7614 44.0299 23.3304 43.8693C14.9924 40.99 7.99414 35.9913 7.99414 25.9937V11.9971C7.99414 11.4668 8.2048 10.9582 8.57978 10.5832C8.95477 10.2083 9.46335 9.9976 9.99365 9.9976C13.9927 9.9976 18.9915 7.59819 22.4706 4.55893C22.8942 4.19702 23.4331 3.99817 23.9902 3.99817C24.5474 3.99817 25.0863 4.19702 25.5099 4.55893C29.009 7.61818 33.9878 9.9976 37.9868 9.9976C38.5171 9.9976 39.0257 10.2083 39.4007 10.5832C39.7757 10.9582 39.9863 11.4668 39.9863 11.9971V25.9937Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <h3 className="fw-bolder mt-lg-3 inter h0 mb-0">Risk Management</h3>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Slider4
